module.exports = __webpack_public_path__ + "img/color_rosegold_a-1755-1.b8304c3.webp";